import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';
import { ordenCompraAdminLst } from 'src/app/models/ordenCompraLst';
import { IndexDetalleOrdenCompraAdminComponent } from '../index-detalle-orden-compra-admin/index-detalle-orden-compra-admin.component';
import { DetalleOrdenCompraReporteAdminComponent } from '../detalle-orden-compra-reporte-admin/detalle-orden-compra-reporte-admin.component';
import { EmpresaService } from 'src/app/services/empresa.service';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-index-orden-compra-admin-historico',
  templateUrl: './index-orden-compra-admin-historico.component.html',
  styleUrls: ['./index-orden-compra-admin-historico.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class IndexOrdenCompraAdminHistoricoComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  public lstClubes: any;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  //searchString: string = '';
  startDate: any;
  endDate: any;
  public clubSelect: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public ordenCompraSvc: OrdenCompraService,
    public dialog: MatDialog,
    public empresaSvc: EmpresaService,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: ordenCompraAdminLst[] = [];
    this.displayedColumns = [
      'empresa',
      'fechaCreacion',
      'valor',
      'fechaFinalizada',
      'numeroRegistros',
      'estado',
      'botones',
    ];

    this.dataSource = new MatTableDataSource<ordenCompraAdminLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getOrdenesCompra(0, 10);
  }

  ngOnInit(): void {
    this.empresaSvc.getEmpresasDropdown().subscribe((clubLst) => {
      console.log(clubLst);
      this.lstClubes = clubLst;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getOrdenesCompra(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.ordenCompraSvc
      .getOrdenesCompraAdminHistorica({
        page,
        numReg,
        empresaId: this.clubSelect,
        fechaInicio: this.startDate?.format('YYYY-MM-DDTHH:mm:ss'),
        fechaFin: this.endDate?.format('YYYY-MM-DDTHH:mm:ss'),
      })
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<ordenCompraAdminLst>(
          result[0]
        );
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getOrdenesCompra(event.pageIndex, event.pageSize);
  }

  cambioClubBuscar() {
    this.getOrdenesCompra(this.pageIndex, this.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getOrdenesCompra(0, 10);
  }

  buscar(){
    this.getOrdenesCompra(0, 10);
  }

  cambioDiscipinaBuscar() {
    this.getOrdenesCompra(this.pageIndex, this.pageSize);
  }

  /*   edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditOrdenCompraComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getOrdenesCompra(this.pageIndex, this.pageSize);
      }
    });
  } */

  /*   delete(obj: any) {
    console.log(obj);
    this.alertify.confirm(
      'Confirma que quiere eliminar el la orden de compra?',
      () => {
        this.ordenCompraSvc.deleteOrdenCompra(obj.id).subscribe((res) => {
          if (res) {
            this.getOrdenesCompra(this.pageIndex, this.pageSize);
            this.alertify.success('Hoario eliminado.');
          } else {
            this.alertify.error('La orden de compra no se ha podido eliminar.');
          }
        });
      }
    );
  } */

  abrirModalDeportistas(obj: any): void {
    let dialogRef = this.dialog.open(IndexDetalleOrdenCompraAdminComponent, {
      data: obj.id,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getOrdenesCompra(this.pageIndex, this.pageSize);
      }
    });
  }

  abrirOrdenCompra(obj: any): void {
    this.alertify.confirm('Confirma abrir la orden de compra?', () => {
      this.ordenCompraSvc.abrirOrdenCompra(obj.id).subscribe((result) => {
        if (result) {
          this.getOrdenesCompra(this.pageIndex, this.pageSize);
          this.alertify.success('Orden de compra abierta');
        } else {
          this.alertify.error('La orden de compra no se puede abrir');
        }
      });
    });
  }

  getValorOrdenCompraFinal(obj: any) {
    this.ordenCompraSvc
      .getValorFinalOrdenCompra(obj.id)
      .subscribe((valorOc) => {
        console.log('el valor final de la orden es:', valorOc);
        this.alertify.confirm(
          'El valor de la orden de compra es: $' +
            valorOc.toLocaleString('es-ES'),
          () => {}
        );
      });
  }

  rechazar(obj: any): void {
    this.alertify.confirm('Confirma el rechazo de la orden de compra?', () => {
      this.ordenCompraSvc.rechazarOrdenCompra(obj.id).subscribe((result) => {
        if (result) {
          this.getOrdenesCompra(this.pageIndex, this.pageSize);
          this.alertify.success('Orden de compra rechazada');
        } else {
          this.alertify.error('La orden de compra no se puede rechazar');
        }
      });
    });
  }

  abrirDetalleOrdenCompra(obj: any): void {
    this.dialog.open(DetalleOrdenCompraReporteAdminComponent, {
      data: obj.id,
    });
  }
}
